export default __webpack_public_path__ + "static/Bearish-2b58ba34e6e300041065553bc023ee31.png";